import { ChamadoViatura } from './../model/chamado-viatura';
import { Injectable } from '@angular/core';
import { CsiHttp } from '../../core/csi-http';
import { environment } from '../../../environments/environment';
import { Utils } from '../../core/utils';

@Injectable()
export class DisponibilidadeRecursoService {
  constructor(private http: CsiHttp) {}
  apiPrincipalURL = environment.principal;

  consultaUnidadePolicialUsuarioLogado() {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaUnidadePolicialUsuarioLogado';
    return this.http.getIgnore(url).map((response: any) => {
      return response;
    });
  }

  getListarUnidPolicialLovUsuAutoComplete(query: string, cdUsuario: number, cdAgencia: number, somenteAtivo: boolean) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/listarUnidPolicialLovUsuAutoComplete';
    url += '?desc=' + query + '&cdUsuario=' + cdUsuario + '&cdAgencia=' + cdAgencia + '&somenteAtivo=' + somenteAtivo;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getListaUnidPolicialLovAgAutoComplete(query: string, cdAgencia: number) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/listarUnidPolicialLovAgAutoComplete';
    url += '?desc=' + query + '&cdAgencia=' + cdAgencia;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getListaUnidPolicialLovAgTodosComplete(query: string, cdAgencia: number) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/listaUnidPolicialLovAgTodosComplete';
    url += '?desc=' + query + '&cdAgencia=' + cdAgencia;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getViaturasFindAllAutoComplete(query: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/getViaturasFindAllAutoComplete';
    url += '?desc=' + query;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getconsultaRegiaoPlanejamentoAutoCompleteDesc(query: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaRegiaoPlanejamentoAutoCompleteDesc';
    url += '?desc=' + query;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaRegiaoPlanejamentoAtivasComplete(query: string, codigo: number, cdAgencia: number ) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaRegiaoPlanejamentoAtivasComplete';
    url += '?desc=' + query + '&codigo=' + codigo + '&cdAgencia=' + cdAgencia;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getconsultarStatusRecursoAutoCompleteDesc(query: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultarStatusRecursoAutoCompleteDesc';
    url += '?desc=' + query;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  getColunasDisponibilidadeRecurso(tela: string) {
    let url =
      this.apiPrincipalURL + '/disponibilidadeRecurso/getColunasDisponibilidadeRecurso';
    url += '?tela=' + tela;
    return this.http.getIgnore(url).map((response: any) => {
      return response;
    });
  }

  consultarDisponibilidadeViaturas(cdViatura: string, cdUnidade: number, cdRegiao: number, idStatus: string, idSituacao: string) {
    let url =
      this.apiPrincipalURL + '/disponibilidadeRecurso/consultarDisponibilidadeViaturas';
     url += '?cdUnidade=' + cdUnidade + '&cdRegiao=' + cdRegiao
     + '&idStatus=' + idStatus + '&idSituacao=' + idSituacao;

     url = Utils.addParam('cdViatura', cdViatura, url);

    return this.http.get(url).map((response: any) => {
      return response;
    });
  }

  carregaListaStatusRecurso() {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/carregaListaStatusRecurso';
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaViaturasSemEmpenho(cdUnidade: number) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaViaturasSemEmpenho';
    url += '?cdUnidade=' + cdUnidade;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  // criar os metodos na controle
  salvarAlocacao(chamadoViatura: ChamadoViatura) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/operacoesChamadoViatura';
    return this.http.post(url, chamadoViatura)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaQuantidadeFuncionariosOcorrencia(chamadoViatura: ChamadoViatura) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaQuantidadeFuncionariosOcorrencia';
    return this.http.post(url, chamadoViatura)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  buscarTurnoViatura(cdViatura: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/buscarTurnoViatura';
    url += '?cdViatura=' + cdViatura;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarDisponibilidadeViaturasPorRegiaoTpVeiculo(cdViatura: string, tpIncidente: string, cdUnidade: number, cdRegiao: number, idSituacao: string, idStatus: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaViaturasPorRegiaoTpVeiculo';
    url += '?cdViatura=' + cdViatura
          + '&tpIncidente=' + tpIncidente
          + '&cdUnidade=' + cdUnidade
          + '&cdRegiao=' + cdRegiao
          + '&idSituacao=' + idSituacao
          + '&idStatus=' + idStatus;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarDisponibilidadeViaturasPorRegiao(cdViatura: string, cdUnidade: number, cdRegiao: number, idSituacao: string, idStatus: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultarDisponibilidadeViaturasPorRegiao';
    url += '?cdViatura=' + cdViatura
          + '&cdUnidade=' + cdUnidade
          + '&cdRegiao=' + cdRegiao
          + '&idSituacao=' + idSituacao
          + '&idStatus=' + idStatus;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarDisponibilidadeViaturasPorRegiaoPlaca(cdViatura: string, cdUnidade: number, cdRegiao: number, idSituacao: string, idStatus: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultarDisponibilidadeViaturasPorRegiaoPlaca';
    url += '?cdViatura=' + cdViatura
      + '&cdUnidade=' + cdUnidade
      + '&cdRegiao=' + cdRegiao
      + '&idSituacao=' + idSituacao
      + '&idStatus=' + idStatus;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }
  consultaRegiaoPorBairro(dsCidade: string, dsBairro: string, cdUnidPolicial: number) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaRegiaoPorBairro';
    url = Utils.addParam('dsCidade', dsCidade, url);
    url = Utils.addParam('dsBairro', dsBairro, url);
    url = Utils.addParam('cdUnidPolicial', cdUnidPolicial, url);
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }
  consultaGuarnicaoAutoComplete(query: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaGuarnicaoAutoComplete';
    url += '?desc=' + query;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  lovAllViaturas(query: string, cdUnidade: number, filtrarUnidade: boolean ) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/lovAllViaturasAutoComplete';
    url += '?desc=' + query + '&cdUnidade=' + cdUnidade + '&filtrarUnidade=' + filtrarUnidade;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  lovAllViaturasPlaca(query: string, cdUnidade: number, filtrarUnidade: boolean ) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/lovAllViaturasPlacaAutoComplete';
    url += '?desc=' + query + '&cdUnidade=' + cdUnidade + '&filtrarUnidade=' + filtrarUnidade;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaViaturas(query: string, cdUnidade: number) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaViaturasAutoComplete';
    url += '?desc=' + query + '&cdUnidade=' + cdUnidade;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  buscaDadosViatura(cdViatura: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/buscaDadosViatura';
    url += '?cdViatura=' + cdViatura;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  entrarEmServico(cdViatura: string) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/entrarEmServico';
    return this.http.postIgnore(url, cdViatura)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  criaTurno(cdGuarnicao: number) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/criaTurno';
    return this.http.postIgnore(url, cdGuarnicao)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  tirarDeServico(cdViatura: string) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/tirarDeServico';
    return this.http.postIgnore(url, cdViatura)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  mudarSituacaoForaServico(cdGuarnicao: number) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/foraServico';
    return this.http.postIgnore(url, cdGuarnicao)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  alterarStatusGuarnicao(cdGuarnicao: number, cdStatusRecurso: number) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/alteraStatusGuarnicao';
    const dadosAltStatus = cdGuarnicao + '-' + cdStatusRecurso;
    return this.http.postIgnore(url, dadosAltStatus)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  alterarStatusViatura(cdViatura: number, cdStatusRecurso: number) {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/alterarStatusViatura';
    const dadosAltStatus = cdViatura + '-' + cdStatusRecurso;
    return this.http.postIgnore(url, dadosAltStatus)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarDisponibilidadeGuarnicao(cdGuarnicao: number, idSituacao: string, idStatus: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/buscaDadosViatura';
    url += '?cdGuarnicao=' + cdGuarnicao + '&idSituacao=' + idSituacao + '&idStatus=' + idStatus;
    return this.http.get(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarRegistroCorrenteViatura(cdViatura: string) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/registroCorrente';
    url += '?cdViatura=' + cdViatura;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarStatusTablet() {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultarStatusTablet';
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaRegiaoPlanejamento() {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaRegiaoPlanejamento';
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultaModPolicialLov() {
    const url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultaModPolicialLov';
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

  consultarUltimoTurnoRecurso(recurso: any) {
    let url = this.apiPrincipalURL + '/disponibilidadeRecurso/consultarUltimoTurnoRecurso';
    url += '?codUnidPolicial=' + recurso.cdUnidPolicial + '&cdAgencia=' + recurso.cdAgencia + '&cdViatura=' + recurso.cdViatura;
    return this.http.getIgnore(url)
      .map(
        (response: any) => {
          return response;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/commons/servicos/disponibilidade-recurso.service.ts